import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import './NavDateRangeSelector.css';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';

const styles = theme => ({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    position: 'relative',
    userSelect: 'none',
    flexDirection: 'row',
    padding: '1rem 0',
    '&:focus': {
      outline: 0
    }
  },
  container: {
    ...theme.typography.body1,
    display: 'inline-block'
  },
  day: {
    ...theme.typography.body1,
    display: 'table-cell',
    padding: '.5rem',
    border: '1px solid #eaecec',
    textAlign: 'center',
    cursor: 'pointer',
    verticalAlign: 'middle'
  },
  NavButton: {
    position: 'absolute',
    width: '1.5rem',
    height: '1.5rem',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    cursor: 'pointer'
  },
  NavButtonNext: {
    right: '1rem',
    color: theme.palette.text.secondary,
    backgroundImage:
      'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=")'
  },
  NavButtonPrev: {
    left: '1rem',
    color: theme.palette.text.secondary,
    backgroundImage:
      'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K")'
  },
  today: {
    color: theme.palette.primary['700'],
    backgroundColor: theme.palette.primary['100']
  },
  selected: {
    '&:not($disabled):not($outside)': {
      backgroundColor: theme.palette.primary['500']
    }
  },
  disabled: {
    color: theme.palette.text.disabled
  },
  outside: {
    color: theme.palette.text.secondary
  }
});

const isSelectingFirstDay = (from, to, day) => {
  const firstDayIsNotSelected = !from;
  const selectedDayIsBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
  const rangeIsSelected = from && to;
  return (
    firstDayIsNotSelected || selectedDayIsBeforeFirstDay || rangeIsSelected
  );
};

class NavDateRangeSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: null,
      to: null,
      enteredTo: null,
      utcOffset: null
    };
  }

  updateFromTo = ({ from, to }) => {
    this.setState({
      from: new Date(from * 1000),
      to: new Date(to * 1000)
    });
  };

  setUtcOffset = timezone => {
    const utcOffset = moment.tz(timezone).utcOffset() * 60; // returns timezone offset in minutes, * 60 = seconds
    this.setState({ utcOffset });
    return utcOffset;
  };

  componentWillMount() {
    const { queryParams: { from, to }, timezone } = this.props;
    const utcOffset = this.setUtcOffset(timezone);

    this.updateFromTo({
      from: this.withLocalTimezone(from, utcOffset), // convert to locale date
      to: this.withLocalTimezone(to, utcOffset) - 1 // convert to locale date
    });
  }

  componentWillReceiveProps(nextProps) {
    const { queryParams: { from, to }, timezone } = nextProps;
    const samplesQueryParamsChanged =
      from !== this.props.queryParams.from || to !== this.props.queryParams.to;
    const timezoneChanged = timezone !== this.props.timezone;

    if (timezoneChanged) {
      this.setUtcOffset(timezone);
    }

    if (samplesQueryParamsChanged) {
      if (from && to) {
        this.updateFromTo({
          from: this.withLocalTimezone(from), // convert to locale date
          to: this.withLocalTimezone(to) - 1 // convert to locale date
        });
      }
    }
  }

  reset = () =>
    this.setState({
      from: null,
      to: null,
      enteredTo: null
    });

  setDateToMidnight = date => date.setHours(0, 0, 0, 0) / 1000; // - this.state.utcOffset;
  withSiteTimezone = date =>
    date - this.state.utcOffset - new Date().getTimezoneOffset() * 60;
  withLocalTimezone = (timestamp, utcOffset) =>
    timestamp +
    (utcOffset ? utcOffset : this.state.utcOffset) +
    new Date().getTimezoneOffset() * 60;

  /*
  The date picker internally works with the javascript date object which always works in the local
  time of the browser.
  Therefore, the unix-timestamp will be converted to a local date and back if the handleClick method
  will be invoked.
  */
  handleDayClick = day => {
    const { from, to } = this.state;

    if (from && to && day >= from && day <= to) {
      this.props.updateQueryParams({ from: null, to: null });
      this.reset();
      return;
    }

    if (isSelectingFirstDay(from, to, day)) {
      this.props.updateQueryParams({
        from: this.withSiteTimezone(this.setDateToMidnight(day)),
        to: null
      }); // convert to remote date
      this.setState({
        from: day,
        to: null,
        enteredTo: null
      });
      return;
    }

    this.setState({
      to: day,
      enteredTo: day
    });

    if (from || day) {
      const fromMidnight = from
        ? this.withSiteTimezone(this.setDateToMidnight(from))
        : null; // convert to remote date
      const toMidnight = day
        ? this.withSiteTimezone(this.setDateToMidnight(day)) + 86400
        : null; // convert to remote date

      this.props.updateQueryParams({
        from: fromMidnight,
        to: toMidnight
      });
    }

    /* if (from && day) {
      const fromMidnight = from.setUTCHours(0, 0, 0, 0);
      const toMidnight = day.setUTCHours(0, 0, 0, 0);

      this.props.updateQueryParams({
        from: (fromMidnight / 1000) - this.state.utcOffset,//  + this.state.utcOffset,
        to: (toMidnight / 1000) - this.state.utcOffset,//  + this.state.utcOffset,
      });
    } */
  };

  render() {
    const { from, to } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <DayPicker
          utc={true}
          numberOfMonths={2}
          selectedDays={[from, { from, to }]}
          onDayClick={this.handleDayClick}
          firstDayOfWeek={1}
          fixedWeeks
          month={from ? from : null}
          classNames={{
            container: classes.container, // 'DayPicker',
            wrapper: classes.wrapper, // 'DayPicker-wrapper',
            interactionDisabled: 'DayPicker--interactionDisabled',
            month: 'DayPicker-Month',

            navBar: 'DayPicker-NavBar',
            navButtonPrev: classNames(classes.NavButton, classes.NavButtonPrev),
            navButtonNext: classNames(classes.NavButton, classes.NavButtonNext),
            navButtonInteractionDisabled:
              'DayPicker-NavButton--interactionDisabled',

            caption: 'DayPicker-Caption',
            weekdays: 'DayPicker-Weekdays',
            weekdaysRow: 'DayPicker-WeekdaysRow',
            weekday: 'DayPicker-Weekday',
            body: 'DayPicker-Body',
            week: 'DayPicker-Week',
            weekNumber: 'DayPicker-WeekNumber',
            day: classes.day,
            footer: 'DayPicker-Footer',
            todayButton: 'DayPicker-TodayButton',

            // default modifiers
            today: classes.today, // 'DayPicker-Day--today',
            selected: classes.selected, // 'DayPicker-Day--selected',
            disabled: 'DayPicker-Day--disabled',
            outside: classes.outside // 'DayPicker-Day--outside'
          }}
        />
      </div>
    );
  }
}

NavDateRangeSelector.propTypes = {
  queryParams: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired
};

export default withStyles(styles, { name: 'DayPicker' })(NavDateRangeSelector);



// WEBPACK FOOTER //
// ./src/components/nav/NavDateRangeSelector.js